import Api from '../../../Api'
import { all } from 'redux-saga/effects'
import { combineReducers } from "redux";
import createTableFetcher from 'common/reducer/createTableFetcher'

// ES6
const getFetcher = state => {
    return state.waas.serverTree.fetcher
}
export const fetcher = createTableFetcher('serverTree', Api.fetchServerTree, getFetcher)

export const types = {
    SET_IS_LOADING: 'APPLICATIONS_TABLE/SET_IS_LOADING',
}

export const actions = {
    setIsLoading: (isLoading) => ({ type: types.SET_IS_LOADING, isLoading }),
    toggleRenameDialog: (id = undefined, name = '') => ({ type: types.TOGGLE_RENAME_DIALOG, id, name }),
    ...fetcher.actions
}

export const initialState = {
    isLoading: false,
    items: [],
}

const serverTree = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
}

export default combineReducers({
    serverTree,
    fetcher: fetcher.reducer
});

export function* serverTreeSaga() {
    yield all([
        fetcher.saga(),
    ])
}